import { render, staticRenderFns } from "./RelatorioGestaoPedidos.vue?vue&type=template&id=b5dc01be&scoped=true"
import script from "./RelatorioGestaoPedidos.vue?vue&type=script&lang=js"
export * from "./RelatorioGestaoPedidos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5dc01be",
  null
  
)

export default component.exports